import cleoPic from "@/public/images/artists/cleo.png";
import { Artist } from "@/types/types";

export const cleo = {
  id: "41",
  name: "Cleo",
  image: cleoPic,
  description: `Cleo is a captivating indie artist known for her ethereal vocals that effortlessly carry a deep well of emotion. With a voice as delicate as a whisper yet expressive enough to move hearts, Cleo's music weaves a spell of introspection and raw vulnerability.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcleo-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Indie", "Dance", "Airy"],
      secondary: ["Singer", "Delicate"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 54,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
